<template>
  <td
    :class="{
      'table-warning': totalSeconds >= 60 && totalSeconds < 120,
      'table-success': totalSeconds < 60,
      'table-danger': totalSeconds >= 120
    }"
    v-html="time"
  ></td>
</template>

<script>
import moment from "moment";
import { defaultNullHtml } from "@/js/defaultNullHtml";

export default {
  props: ["content"],
  data() {
    return {
      now: moment(),
      intervalId: null
    };
  },
  created() {
    this.intervalId = setInterval(() => {
      this.now = moment();
    }, 1000);
  },
  computed: {
    time() {
      if (this.content === null) {
        return defaultNullHtml();
      }

      const seconds = this.totalSeconds % 60;
      const minutes = Math.floor(this.totalSeconds / 60) % 60;
      const hours = Math.floor(this.totalSeconds / 3600);

      return `${this.numberFormat(hours)}:${this.numberFormat(
        minutes
      )}:${this.numberFormat(seconds)}`;
    },
    totalSeconds() {
      return Math.round(
        moment.duration(this.now.diff(moment(this.content))).asSeconds()
      );
    }
  },
  methods: {
    numberFormat(number) {
      const formatter = new Intl.NumberFormat("de-DE", {
        maximumFractionDigits: 0,
        minimumIntegerDigits: 2
      });

      return formatter.format(number);
    }
  },
  destoryed() {
    clearInterval(this.intervalId);
  }
};
</script>
